import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";

export default function(props) {
  return (
    <div style={{ padding: "7px" }}>
      <div style={getStyleJSON("font-size: 10px; color: blue;")} colspan="2">
        {props.children}
      </div>
    </div>
  );
}
